import { render, staticRenderFns } from "./MComboTree.vue?vue&type=template&id=4682ae1a&scoped=true"
import script from "./MComboTree.vue?vue&type=script&lang=js"
export * from "./MComboTree.vue?vue&type=script&lang=js"
import style0 from "./MComboTree.vue?vue&type=style&index=0&id=4682ae1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4682ae1a",
  null
  
)

export default component.exports